import { useListOrder } from '../../filter';
import { AccountListOrderKey } from '../domain';

export const useAccountListOrder = () => {
  return useListOrder(AccountListOrderKey, 'accountOrderBy', true);
};
